import React from 'react';
import { kurzDatum, ortText, standText, type ZaehlerZeile } from '../../../../lib/zaehler/liste';
import { TypChip, TypIcon } from '../teile';

/** Kachel (Handoff Zähler §5.1): Typ-Icon, Nummer, Objekt · Einheit, Typ-Chip; letzter Stand · Datum · Status. */
export const ZaehlerKachel = React.memo(function ZaehlerKachel({ z, onOeffnen }: { z: ZaehlerZeile; onOeffnen: (id: string) => void }) {
  const tastatur = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOeffnen(z.id); }
  };
  const ort = ortText(z);
  return (
    <article role="link" tabIndex={0} aria-label={`Zähler ${z.zaehler_nummer} öffnen`} onClick={() => onOeffnen(z.id)} onKeyDown={tastatur}
      className="immo-glas immo-hover-kachel flex flex-col cursor-pointer min-w-0" style={{ borderRadius: 22, padding: 14, gap: 10 }}>
      <div className="flex items-center min-w-0" style={{ gap: 10 }}>
        <TypIcon typ={z.typ} />
        <div className="flex flex-col flex-1 min-w-0" style={{ gap: 1 }}>
          <span className="immo-zahl truncate" style={{ fontSize: 15, fontWeight: 800 }}>{z.zaehler_nummer}</span>
          {ort && <span className="truncate" style={{ fontSize: 12, color: 'var(--ink3)' }}>{ort}</span>}
        </div>
        <TypChip typ={z.typ} />
      </div>
      <div className="flex items-baseline flex-wrap min-w-0" style={{ gap: '0 6px', fontSize: 12 }}>
        {z.letzteAblesung ? (
          <>
            <b className="immo-zahl whitespace-nowrap" style={{ fontSize: 16, fontWeight: 800 }}>{standText(z.letzteAblesung.wert, z.einheit)}</b>
            <span className="immo-zahl" style={{ color: 'var(--ink3)' }}>· {kurzDatum(z.letzteAblesung.datum)}</span>
          </>
        ) : (
          <span style={{ fontWeight: 700, color: 'var(--ink3)' }}>Keine Ablesung</span>
        )}
        <span style={{ fontWeight: 800, color: z.aktiv ? 'var(--ok)' : 'var(--ink3)' }}>· {z.aktiv ? 'Aktiv' : 'Inaktiv'}</span>
      </div>
    </article>
  );
});
